import { useRef, useState, useCallback } from 'react';
import cx from 'classnames';
import styles from './Dropdown.module.scss.js';
import Icon from '../Icon/Icon.js';
import RadioItem from './RadioItem/RadioItem.js';
import useEscapeHandlers from '../../util/useEscapeHandlers.js';
import { kebabCase } from '../../util/stringUtils.js';
import { Size, Variant } from './types.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Dropdown = ({
  classFieldset,
  title,
  options,
  onChange,
  selected = 0,
  setSelected,
  size = Size.small,
  variant = Variant.outlined
}) => {
  const wrapperRef = useRef(null);
  const focusRef = useRef(null);
  const buttonRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useEscapeHandlers(isOpen, setIsOpen, wrapperRef, focusRef);
  const handleChange = useCallback((idx) => {
    if (onChange) {
      onChange(idx);
    }
  }, [onChange]);
  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const offset = () => {
    if (buttonRef.current) {
      return buttonRef.current.offsetHeight;
    }
    return 53;
  };
  const selectedLabel = `${options[selected].label} ${options[selected].labelAdditional ? ` (${options[selected].labelAdditional})` : ""}`;
  const buttonStyles = cx(styles.dropdownButton, styles[variant], styles[size]);
  const containerStyles = cx(styles.container, styles[size]);
  const fieldsetStyles = cx(styles.fieldset, classFieldset);
  return /* @__PURE__ */ jsxs("div", {
    className: styles.wrapper,
    ref: wrapperRef,
    "data-test-id": "dropdown",
    children: [/* @__PURE__ */ jsx("button", {
      "data-test-id": "dropdown-button",
      className: buttonStyles,
      onClick: handleOpen,
      ref: buttonRef,
      children: /* @__PURE__ */ jsxs("div", {
        className: containerStyles,
        children: [title && /* @__PURE__ */ jsx("span", {
          className: styles.title,
          children: title
        }), /* @__PURE__ */ jsxs("div", {
          className: styles.content,
          children: [/* @__PURE__ */ jsx("span", {
            children: selectedLabel
          }), isOpen ? /* @__PURE__ */ jsx(Icon, {
            iconName: "arrows.up",
            iconColor: "contentLink",
            className: styles.icon
          }) : /* @__PURE__ */ jsx(Icon, {
            iconName: "arrows.down",
            iconColor: "contentLink",
            className: styles.icon
          })]
        })]
      })
    }), isOpen && /* @__PURE__ */ jsx("fieldset", {
      className: fieldsetStyles,
      ref: focusRef,
      "data-test-id": "dropdown-content",
      style: {
        top: offset() + 8
      },
      children: options.map((option, idx) => {
        return /* @__PURE__ */ jsx(RadioItem, {
          label: option.label,
          labelAdditional: option.labelAdditional,
          selectedOption: options[selected],
          onChange: () => handleChange(idx),
          setDropdownOpen: handleOpen,
          setSelectedOption: () => setSelected(idx),
          dataTestId: kebabCase(option.labelAdditional ? `${option.label} ${option.labelAdditional}` : `${option.label}`)
        }, option.label);
      })
    })]
  });
};

export { Dropdown as default };
//# sourceMappingURL=Dropdown.js.map
